
























































































































































































































































































































































































































































































































































import moment from 'moment';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY as PARENT_STORE_KEY } from '../../ShiftVDP/_store';
import { STORE_KEY, store } from './_store';

import IncidentCombobox from '@/components/Controls/IncidentCombobox.vue';
import Attachments from '@/components/Controls/Attachments.vue';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(PARENT_STORE_KEY, [
      'prevDocumentId'
    ]),
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta',
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  components: {
    IncidentCombobox,
    Attachments
  },
  validations() {
    const rules: any = {
      plan_id: { required },
      bottling_plan_id: {},
      datetime: { required },
      release_datetime: {},
      density_vpr: {},
      speed_vpr: {},
      viscosity_vpr: {},
      resistance_vpr: {},
      temp_vpr: {},
      acidity_ohaus_vpr: {},
      acidity_mettler_vpr: {},
      density_gph: {},
      speed_gph: {},
      viscosity_gph: {},
      resistance_gph: {},
      temp_gph: {},
      stirability_thermomix_id: {},
      glitter_thermomix_id: {},
      thermal_stability_id: {},
      heat_resistance_id: {},
      hardness_id: {},
      causticity_initial_spalling_id: {},
      plasticity_id: {},
      looseness_id: {},
      sound_product_breaking_id: {},
      sound_product_released_id: {},
      feeling_of_texture_id: {},
      fluff_effect_id: {},
      creaminess_longitude: {},
      creaminess_height: {},
      kislinka_id: {},
      serbian_profile_id: {},
      sweetness_id: {},
      salinity_id: {},
      vices_id: {},
    }

    return {
      form: rules
    }
  }
})
export default class ShiftAtomLaboratoryForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;
  @Prop({ type: String }) documentId!: any;

  document!: any
  form!: any
  prevPlansList!: any
  starter_type_code: any = 't'

  termocameras: any[] = [
    {id: 1, label: '1'},
    {id: 2, label: '2'},
    {id: 3, label: '3'},
  ]

  directs: any[] = [
    {id: 'up', label: 'верх'},
    {id: 'dowm', label: 'низ'},
  ]

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  get newDay(){
    return moment().hours()  < 9;
  }

  public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
  }

  addAttachments(file: any) {
    this.$store.dispatch(`${STORE_KEY}/addAttachments`, {newValue: file});
  }

  removeFile( idx: number, data: any) {
    this.form.attachments.splice(idx, 1)
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    // this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  onContainerChange($event: any) {
    if ($event && $event.label) {
      this.changeValue('container_weight', $event.weight);
      this.changeValue('container_tare_weight', $event.tare_weight);
    }
  }

  onPlanDVP($event: any) {
    if ($event && $event.label) {
      this.changeValue('starter_type_code', $event.starter_type_code);
    }
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

